import React from 'react';

const Art = () => {
  return (
    <>
      {/* Mother Hunger Section */}
      <section id="mother-hunger" className="py-32 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-light text-center tracking-wide mb-4">"THE MOTHER OF HUNGER" - MMATLALA</h2>
          <div className="section-divider"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mt-16">
            <div className="flex flex-col justify-center" data-aos="fade-right">
              <p className="text-gray-700 mb-6 leading-relaxed">
                Botswalle forms a platform that she can exercise what she has been called to do by her people as a leader and healer, 
                which in her case is Mme wa ditlala "mother of hunger" A journey she walks figuratively, to feed people through motivation, 
                therapy, motherly care and her advocacy for humanity. The journey of seeing her self as others and others as herself.
              </p>
              
              <p className="text-gray-700 mb-6 leading-relaxed">
                This is what she was called to do as her grandmother named her after herself. Ensuring that her legacy of mothering 5 children 
                continues through her granddaughter. But not only will she know the experience of Mothering through her name she will mother 
                way more than the 5 that she had. The unravelling poetry of this name, connecting roots the motherlands of the rainmakers 
                that rule over them.
              </p>
              
              <p className="text-gray-700 leading-relaxed">
                Mmatlala takes pride in being a link to quench the thirst of those who are thirsty and those who are hungry. But this is not 
                figurative to her as she believes the only to that is to feed the soul, through words and actions that can reach those areas 
                of thirst and hunger. To feed the mind, is to feed the soul and for that the body has also found mindfulness and soulfulness.
              </p>
            </div>
            <div data-aos="fade-left">
              <img 
                src="/images/image00015.jpeg" 
                alt="Khosikhadi in traditional attire holding bananas" 
                className="w-full object-cover h-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Art Section */}
      <section id="art" className="py-32 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-light text-center tracking-wide mb-4">ART & KHOSIKHADI MMATLALA WA MUDAU</h2>
          <div className="section-divider"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mt-16">
            <div className="flex flex-col justify-center" data-aos="fade-right">
              <p className="text-gray-700 mb-6 leading-relaxed">
                Khosikhadi is storyteller, since her primary ages. She used to dance for a cultural group named "Dithakadu". 
                In high school she was involved in school plays winning sliver in the competition Drama for Life Mavuso School & Community 
                Education Project in 2013. Over the years storytelling took premise in her development as child, teenage and young adult. 
                Therefore acquiring an undergrad in BSS majoring in drama & performance studies. Securing featured extra roles in shows 
                such Rhythm city (2018), & Entangled (2022)
              </p>
              
              <p className="text-gray-700 mb-6 leading-relaxed">
                Acting is not her only tool of storytelling, she is a poet nourished in her home language, Khelobedu and other various 
                languages she has come to speak e.g. Setswana, Isizulu and English. Even though she may not speak these languages as the 
                originators of them, she values being born from a diverse Nation in South Africa.
              </p>
              
              <p className="text-gray-700 mb-6 leading-relaxed">
                She enjoys writing poetry, passages, play scripts, screenplays and novel stories. She plans to someday become a publishing 
                author. Although for now she expresses her love for writing through self-tapes expressing monologues and poetry on her 
                social media platforms.
              </p>
              
              <p className="text-gray-700 leading-relaxed">
                Her most celebrated journey is her modeling, which she tells stories through her pictorial images on social media. 
                Also securing tv advertisements as a commercial model.
              </p>
            </div>
            <div data-aos="fade-left">
              <div className="grid grid-cols-1 gap-6">
                <img 
                  src="/images/image00016.jpeg" 
                  alt="Khosikhadi in traditional attire" 
                  className="w-full object-contain h-64"
                />
                <img 
                  src="/images/image00017.jpeg" 
                  alt="Khosikhadi performing" 
                  className="w-full object-contain h-64"
                />
                <img 
                  src="/images/image00018.jpeg" 
                  alt="Khosikhadi in colorful attire" 
                  className="w-full object-contain h-64"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Art;